import type { SuggestedSize, UserSelectedSize } from '@/types/sizes'

/**
 * The primary size to display from the sizing v2 shape {value, scaleCode,
 * display}, falling back to the legacy fields during backend rollout.
 * display.INT (alpha) wins over value because the cards show the international
 * size.
 */
export function primarySize(
  entry: SuggestedSize | UserSelectedSize | null | undefined,
): string | null {
  if (!entry) return null
  return (
    entry.display?.INT ??
    entry.value ??
    entry.sizeInternational ??
    entry.display?.EU ??
    entry.sizeEuropean ??
    null
  )
}

/** The size value in a specific system (INT/EU/RU), with a legacy fallback */
export function sizeInSystem(
  entry: SuggestedSize | UserSelectedSize | null | undefined,
  system: 'INT' | 'EU' | 'RU',
): string | null {
  if (!entry) return null
  if (entry.display?.[system]) return entry.display[system]
  if (system === 'INT') return entry.sizeInternational ?? entry.value ?? null
  if (system === 'EU') return entry.sizeEuropean ?? null
  return entry.sizeRussian ?? null
}
